import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ec-59a9589f-556f-498d-a7fe-2c931fed9580-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-00e82b2c-356c-4290-b60c-1f8b3bb1d4b3-__Layer_2_1_\"><g id=\"ec-0df5632c-cc8f-4ba2-a922-edb092860258-__Layer_1-2\"><g id=\"ec-57f2fc1b-9165-44d5-bff4-9495b5e3991f-__format_align_right\"><path d=\"m63 15h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 31h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 47h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 63h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path></g></g></g>", 1)
  ]))]))
}
export default { render: render }